import { z } from 'zod'

import { BARRIER_TYPES } from '@/pages/instruments/new-instrument/constants/barrier-types'

export const barrierTypeSchema = z.enum(BARRIER_TYPES)
